import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Skeleton,
    TableContainer,
    Menu,
    MenuItem,
    Button,
    Tooltip

} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import CheckBoxSec from './CheckBoxSec';
import PermissionLegend from './PermissionLegend'

import ConfirmChanges from '../../../components/Projects/ConfirmChanges';


const projects = [
    {
        field: 'Organization',
        headline: 'Change org level permissions (view and edit permissions tab)',
        toggle: false,
        contentTootltop: false,
    },
    {
        field: 'Members',
        headline: 'Invite members or create member accounts',
        toggle: false,
        contentTootltop: false,
    },
    {
        field: 'Activity',
        headline: 'View screenshots/activity for other members',
        toggle: false,
        contentTootltop: <Tooltip title="This feature has exceptions for the organization manager role. Manage permission exceptions at member profile." arrow placement="top" alignContent="center">
            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                <InfoOutlineIcon fontSize="small" />
            </button>
        </Tooltip>,
    },
    {
        field: 'Financials',
        headline: 'Manage financials',
        toggle: false,
        contentTootltop: <Tooltip title="This feature has exceptions for the organization manager role. Manage permission exceptions at member profile." arrow placement="top" alignContent="center">
            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                <InfoOutlineIcon fontSize="small" />
            </button>
        </Tooltip>,
    },
];

const RolePermissionsTable = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);




    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', }}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#DFDFDF', }}>

                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}></TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>
                                <Box display="flex" alignItems="center" justifyContent="center" sx={{ gap: '12px' }}>Org Manager
                                    <Tooltip title="Can do everything, except manage financials (depending on permissions) and send payments" arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" sx={{ fontSize: '14px' }} />
                                        </button>
                                    </Tooltip>
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>
                                <Box display="flex" alignItems="center" justifyContent="center" sx={{ gap: '12px' }}>Project Manager
                                    <Tooltip title="Can manage, track, view screenshots of members they oversee and report for any project they're added to" arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" sx={{ fontSize: '14px' }} />
                                        </button>
                                    </Tooltip>
                                </Box>
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>
                                <Box display="flex" alignItems="center" justifyContent="center" sx={{ gap: '12px' }}>Project Viewer
                                    <Tooltip title="Project viewers can view reports for any projects they're added to." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" sx={{ fontSize: '14px' }} />
                                        </button>
                                    </Tooltip>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                        {loading
                            ? [...Array(4)].map((_, i) => (
                                <TableRow key={i}>
                                    {[...Array(4)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))
                            : projects.map((project, index) => (
                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px', fontFamily: 'Manrope' }}>
                                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', lineHeight: '1', fontSize: '16px', fontWeight: '600', color: '#1A1F36', fontFamily: 'Manrope' }}>{project.field}<span>{project.contentTootltop}</span></Typography>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Typography display="flex" alignItems="center" sx={{ fontSize: '14px', fontWeight: '400', color: '#8C8C8C', fontFamily: 'Manrope' }}>{project.headline}</Typography>
                                            <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#8C8C8C', fontFamily: 'Manrope' }}>{project.toggle}</Typography>
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <CheckBoxSec projects={[{ name: true }]} />
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <CheckBoxSec projects={[{ name: false, }]} />
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>
                                        <Box display="flex" justifyContent="center" alignItems="center" > 
                                            <CheckBoxSec projects={[{ name: true }]} />
                                        </Box>

                                    </TableCell>

                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <PermissionLegend />
            </TableContainer>


        </div>
    )
}

export default RolePermissionsTable
